import { API_AUTH } from "../common";
import { API_AUTH_FILE } from "../common";
const KiemKeApi = {
  getList: (params) => API_AUTH.get("api/kiemke/danhsach",  params),
  addKiemKe: (data) => API_AUTH.post("api/kiemke/themmoi", data),
  updateKiemKe: (payload) => {
    const url = `api/kiemke/capnhat/${payload.KiemKeId}`;
    return API_AUTH.put(url, payload);
  
},
 xuatExcelKiemKe: (kiemKeId) => {
    const url = `api/kiemke/xuat-excel/${kiemKeId}`;
    return API_AUTH_FILE.get(url, {}, { responseType: 'blob' });
  },
};

export default KiemKeApi;
